import {
  PropsWithChildren,
  ReactNode,
  useCallback,
  useMemo,
  useState,
} from "react";
import { DrawerContextValue, IDrawerOprtions, IDrawerState } from "./types";
import { DrawerContext } from "./context";
import { Drawer } from "@/shared/ui/drawer/Drawer";

export const DrawerProvider = ({ children }: PropsWithChildren) => {
  const [drawer, setDrawer] = useState<IDrawerState>({
    isOpen: false,
    node: null,
    options: null,
  });
  const openDrawer = useCallback(
    (node: ReactNode, options: IDrawerOprtions) => {
      setDrawer({ isOpen: true, node, options: options ?? null });
    },
    [],
  );
  const closeDrawer = useCallback(() => {
    setDrawer((prev) => {
      prev.options?.onClose?.();
      return { isOpen: false, node: null, options: null };
    });
  }, []);

  const value: DrawerContextValue = useMemo(
    () => ({
      drawer,
      openDrawer,
      closeDrawer,
    }),
    [drawer, openDrawer, closeDrawer],
  );
  return (
    <DrawerContext.Provider value={value}>
      {children}
      <Drawer drawer={drawer} onClose={closeDrawer} />
    </DrawerContext.Provider>
  );
};
